import parse from "html-react-parser";
type RenderRichTextProp = {
  content: string;
  color?: boolean;
  clamp?: boolean;
};

const RenderRichText: React.FC<RenderRichTextProp> = ({
  content,
  color = false,
  clamp = false,
}: any) => {
  return content ? (
    <div
      className={`text-justify ${clamp && "line-clamp-2 p-0"} ${
        color && "text-[#0C4654]"
      }`}
    >
      {parse(content)}
    </div>
  ) : (
    <></>
  );
};

export default RenderRichText;
